interface CashDrawerStatusIndicatorProps {
  status?: 'ready' | 'open' | 'error' | 'locked';
  onClick?: () => void;
  onViewDetails?: () => void;
}

export default function CashDrawerStatusIndicator({ status = 'ready', onClick, onViewDetails }: CashDrawerStatusIndicatorProps) {
  const statusConfig = {
    ready: {
      icon: 'ri-safe-2-line',
      text: 'Drawer Ready',
      bgColor: 'bg-green-500',
      textColor: 'text-green-100',
    },
    open: {
      icon: 'ri-safe-2-fill',
      text: 'Drawer Open',
      bgColor: 'bg-orange-500',
      textColor: 'text-orange-100',
      pulse: true,
    },
    error: {
      icon: 'ri-error-warning-line',
      text: 'Drawer Error',
      bgColor: 'bg-red-500',
      textColor: 'text-red-100',
    },
    locked: {
      icon: 'ri-lock-line',
      text: 'Drawer Locked',
      bgColor: 'bg-gray-500',
      textColor: 'text-gray-100',
    },
  };

  const config = statusConfig[status];
  const handleClick = onClick || onViewDetails;

  return (
    <div 
      onClick={handleClick}
      className={`flex items-center gap-2 px-3 py-2 ${config.bgColor} rounded-lg ${handleClick ? 'cursor-pointer hover:opacity-90' : ''} transition-all`}
    >
      <i className={`${config.icon} text-lg ${config.textColor} ${config.pulse ? 'animate-pulse' : ''}`}></i>
      <div>
        <p className={`text-xs ${config.textColor} whitespace-nowrap font-medium`}>{config.text}</p>
      </div>
    </div>
  );
}
